import { uuidv7 } from 'uuidv7';

export const ID_PREFIXES = {
  user: 'usr',
  workspace: 'wsp',
  folder: 'fld',
  project: 'prj',
  milestone: 'mls',
  task: 'tsk',
  checklistItem: 'chk',
  comment: 'cmt',
  label: 'lbl',
  taskType: 'typ',
  taskLink: 'lnk',
  timeEntry: 'tme',
  channel: 'chn',
  channelFolder: 'cfd',
  message: 'msg',
  reaction: 'rct',
  attachment: 'att',
  inboxItem: 'inb',
  activity: 'act',
  call: 'cal',
  doc: 'kdc',
  storageFolder: 'sfd',
  userGroup: 'ugr',
  annotation: 'ann',
  modelAnnotation: 'ann',
  annotationComment: 'anc',
} as const;

export type IdKind = keyof typeof ID_PREFIXES;

const REPLAYABLE_ID = /^[a-z]{3}_[0-9a-f-]{36}$/;

let recordedIds: string[] | null = null;
let replayQueues: Map<string, string[]> | null = null;

export function startIdRecording(): void {
  recordedIds = [];
}

export function stopIdRecording(): string[] {
  const ids = recordedIds ?? [];
  recordedIds = null;
  return ids;
}

export function beginIdReplay(ids: readonly string[]): void {
  const queues = new Map<string, string[]>();
  for (const id of ids) {
    if (!REPLAYABLE_ID.test(id)) {
      continue;
    }
    const prefix = id.slice(0, 3);
    const queue = queues.get(prefix);
    if (queue === undefined) {
      queues.set(prefix, [id]);
    } else {
      queue.push(id);
    }
  }
  replayQueues = queues;
}

export function endIdReplay(): void {
  replayQueues = null;
}

export function newId(kind: IdKind): string {
  const prefix = ID_PREFIXES[kind];
  const id = replayQueues?.get(prefix)?.shift() ?? `${prefix}_${uuidv7()}`;
  recordedIds?.push(id);
  return id;
}
